import * as React from "react";
import AspectRatio from "@mui/joy/AspectRatio";
import Typography from "@mui/joy/Typography";
import Card from "@mui/joy/Card";
import List from "@mui/joy/List";
import ListDivider from "@mui/joy/ListDivider";
import ListItem from "@mui/joy/ListItem";
import ListItemContent from "@mui/joy/ListItemContent";
import ListItemButton from "@mui/joy/ListItemButton";
import { HiDevicePhoneMobile } from "react-icons/hi2";
import useDeviceStore from "../store/deviceStore";

export default function StackDevices({ data }) {
  const setSelectedDevice = useDeviceStore((state) => state.setSelectedDevice);
  const handleSelect = (serial) => {
    const device = data.find((d) => d.serial_number === serial);
    console.log(device);
    if (device) {
      setSelectedDevice(device);
    }
  };

  return (
    <Card variant="outlined" sx={{ width: "100%", p: 0 }}>
      <List sx={{ py: "var(--ListDivider-gap)" }}>
        {data.map((item, index) => (
          <React.Fragment key={item.uuid}>
            <ListItem>
              <ListItemButton
                sx={{ gap: 2 }}
                onClick={() => handleSelect(item.serial_number)}
              >
                <AspectRatio
                  className="bg-red-500"
                  sx={{ flexBasis: 120, bgcolor: "red" }}
                >
                  <HiDevicePhoneMobile />
                </AspectRatio>
                <ListItemContent>
                  <Typography sx={{ fontWeight: "md" }}>
                    {item.model}
                  </Typography>
                  <Typography level="body-sm">{item.serial_number}</Typography>
                </ListItemContent>
              </ListItemButton>
            </ListItem>
            {index !== data.length - 1 && <ListDivider />}
          </React.Fragment>
        ))}
      </List>
    </Card>
  );
}
